// Math utilty functions

export const mathMin = Math.min

export const mathMax = Math.max

export const mathAbs = Math.abs

export const mathCeil = Math.ceil

export const mathFloor = Math.floor

export const mathPow = Math.pow

export const mathRound = Math.round
